import store from '../../store'
export default {
    actions: {
        async fetchMails(ctx) {
            const options = {
                method: 'post',
                headers: store.state.headers,
            }
            const res = await fetch('https://api.expansium.ru/admin/api/v1/getUserEmails', options);
            const mails = await res.json();
            ctx.commit('updateEmails', mails);
        },
        async fetchSms(ctx) {
            const options = {
                method: 'post',
                headers: store.state.headers,
            }
            const res = await fetch('https://api.expansium.ru/admin/api/v1/getUserSmsNames', options);
            const sms = await res.json();
            ctx.commit('updateSms', sms);
        },
        async fetchUrls(ctx){
            const options = {
                method: 'post',
                headers: store.state.headers,
            }
            const res = await fetch('https://api.expansium.ru/admin/api/v1/getUserShortUrls', options);
            const urls = await res.json();
            ctx.commit('updateUrls', urls);
        },
        async fetchFields(ctx){
            const options = {
                method: 'post',
                headers: store.state.headers,
            }
            const res = await fetch('https://api.expansium.ru/admin/api/v1/getDynamicFields', options);
            const urls = await res.json();
            ctx.commit('updateFields', urls);
        },
        createMail(ctx, data){
            const options = {
                method: 'post',
                headers: store.state.headers,
                body: JSON.stringify(data)
            }
            return new Promise((resolve, reject) => {
                fetch('https://api.expansium.ru/admin/api/v1/createUserEmail', options)
                    .then(async response => {
                        const data = await response.json();
                        if (!data.status) {
                            reject(data.errors);
                        }
                        resolve(data);
                    });
            });
        },
        createSmsName(ctx, data){
            const options = {
                method: 'post',
                headers: store.state.headers,
                body: JSON.stringify(data)
            }
            return new Promise((resolve, reject) => {
                fetch('https://api.expansium.ru/admin/api/v1/createUserSmsName', options)
                    .then(async response => {
                        const data = await response.json();
                        if (!data.status) {
                            reject(data.errors);
                        }
                        resolve(data);
                    });
            });
        },
        createUrl(ctx, data){
            const options = {
                method: 'post',
                headers: store.state.headers,
                body: JSON.stringify(data)
            }
            return new Promise((resolve, reject) => {
                fetch('https://api.expansium.ru/admin/api/v1/createUserUrl', options)
                    .then(async response => {
                        const data = await response.json();
                        if (!data.status) {
                            reject(data.errors);
                        }
                        resolve(data);
                    });
            });
        },
        createField(ctx, data){
            const options = {
                method: 'post',
                headers: store.state.headers,
                body: JSON.stringify(data)
            }
            return new Promise((resolve, reject) => {
                fetch('https://api.expansium.ru/admin/api/v1/createDynamicField', options)
                    .then(async response => {
                        const data = await response.json();
                        if (!data.status) {
                            reject(data.errors);
                        }
                        resolve(data);
                    });
            });
        },
        verifyToken(ctx, data){
            const options = {
                method: 'get',
                headers: store.state.headers,
            }
            return new Promise((resolve, reject) => {
                fetch('https://api.expansium.ru/admin/api/v1/verification-mail?' + data, options)
                    .then(async response => {
                        const data = await response.json();
                        if (!data.status) {
                            reject(data.errors);
                        }
                        resolve(data);
                    });
            });
        }
    },
    mutations: {
        updateEmails(state, mails){
            state.emails = mails;
        },
        updateSms(state, sms){
            state.nSms = sms;
        },
        updateUrls(state, urls){
            state.urls = urls;
        },
        updateFields(state, fields){
            state.fields = fields;
        }
    },
    state: {
        emails: [],
        nSms: [],
        urls: [],
        fields: [],
        errors: [],
    },
    getters: {
        allMails(state){
            return state.emails;
        },
        allSms(state){
            return state.nSms;
        },
        allUrls(state){
            return state.urls;
        },
        allFields(state){
            return state.fields;
        }
    },
}